import { createSlice } from '@reduxjs/toolkit'

const recordingRulesModalSlice = createSlice({
  name: 'recordingRulesModal',
  initialState: {
    showModal: false,
  },
  reducers: {
    closeRecordingRulesModal: (state) => {
      state.showModal = false
    },
    showRecordingRulesModal: (state) => {
      state.showModal = true
    },
  },
})

export const {
  reducer,
  actions: {
    closeRecordingRulesModal,
    showRecordingRulesModal,
  },
} = recordingRulesModalSlice
